<template>
  <div>
    <div v-if="loading" class="flex justify-center py-10">
      <div
        class="h-10 w-10 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"
        role="status"
        aria-label="Chargement"
      />
    </div>

    <div v-if="error" class="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800" role="alert">
      {{ error }}
    </div>

    <div v-if="!loading && !error" class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div class="staff-stat-card staff-stat-card--gold">
        <div class="mb-2 flex items-center justify-between gap-2">
          <div class="staff-stat-card__label">Total Client</div>
          <UsersIcon class="staff-stat-card__icon h-5 w-5 shrink-0 opacity-80" aria-hidden="true" />
        </div>
        <div class="staff-stat-card__value">{{ totalClient }}</div>
      </div>

      <div class="staff-stat-card staff-stat-card--success">
        <div class="mb-2 flex items-center justify-between gap-2">
          <div class="staff-stat-card__label">Messages envoyés</div>
          <ChatBubbleLeftRightIcon class="staff-stat-card__icon h-5 w-5 shrink-0 opacity-80" aria-hidden="true" />
        </div>
        <div class="staff-stat-card__value">{{ totalMessages }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { UsersIcon, ChatBubbleLeftRightIcon } from '@heroicons/vue/24/outline';
import { clearAuthenticatedSession, isAuthenticatedSession } from '@/utils/sessionAuth';

export default {
  name: 'StatsEmploye',
  components: { UsersIcon, ChatBubbleLeftRightIcon },
  data() {
    return {
      totalMessages: 0,
      totalClient: 0,
      loading: false,
      error: null,
    };
  },
  methods: {
    getValidToken() {
      try {
        return isAuthenticatedSession() ? '1' : null;
      } catch (_) {
        return null;
      }
    },
    async fetchStats() {
      this.loading = true;
      this.error = null;

      try {
        const token = this.getValidToken();
        if (!token) {
          this.error = 'Session invalide ou expirée. Veuillez vous reconnecter.';
          try {
            clearAuthenticatedSession();
          } catch (_) {}
          return;
        }
        const statsResponse = await axios.get('/api/admin/stats-dashboard/', { withCredentials: true });
        const statsData = statsResponse.data;

        this.totalMessages = statsData.total_messages || 0;
        this.totalClient = statsData.total_clients ?? statsData.total_client ?? 0;
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques employé:', error);
        this.error = 'Impossible de charger les statistiques.';
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchStats();
  },
};
</script>
